<template>
  <div class="horizontal-menu flex justify-start hide-scollbar f5 ph3-l">
    <div v-for="(m, index) in items" :key="index" class="pointer pv2 ph3 bg-transparent ttu f6 tc"
      :class="[value === index ? 'horizontal-selected-menu-item' : 'horizontal-default-menu-item']"
      @click="$emit('input', index)">
      {{ m.name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => { return [] }
    },
    value: null
  }
}
</script>

<style lang="scss" scoped>
.horizontal-menu {
  border-bottom-style: solid;
  border-bottom-width: .25rem;
  border-color: #BCCCDC;
  overflow-x: scroll;
}
.horizontal-menu-item {
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.horizontal-default-menu-item {
  @extend .horizontal-menu-item;
  color: #627D98;
}
.horizontal-selected-menu-item {
  @extend .horizontal-menu-item;
  color: #F9703E;
}
</style>
